<script>
import { useAlert } from 'dashboard/composables';
import BranchForm from '../BranchForm.vue';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';

export default {
  components: {
    BranchForm,
    PageHeader,
  },
  data() {
    return {
      enabledFeatures: {},
    };
  },
  methods: {
    async createBranch(data) {
      try {
        const response = await this.$store.dispatch('branches/create', {
          ...data,
        });
        const branch = response.data;

        router.replace({
          name: 'settings_branches_add_agents',
          params: {
            page: 'new',
            branchId: branch.id,
          },
        });
      } catch (error) {
        useAlert(
          this.$t('BRANCHES_SETTINGS.CREATE_FLOW.CREATE.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6 overflow-y-auto">
    <PageHeader
      :header-title="$t('BRANCHES_SETTINGS.CREATE_FLOW.CREATE.TITLE')"
      :header-content="$t('BRANCHES_SETTINGS.CREATE_FLOW.CREATE.DESC')"
    />
    <div class="flex flex-wrap">
      <BranchForm
        :on-submit="createBranch"
        :submit-in-progress="false"
        :submit-button-text="$t('BRANCHES_SETTINGS.FORM.SUBMIT_CREATE')"
      />
    </div>
  </div>
</template>
